module.exports = __webpack_public_path__ + "static/img/32.29c5272.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/32.png
// module id = qXUb
// module chunks = 0